export default __webpack_public_path__ + "static/media/logo-black.699d15d0.png";